export const MINERU_CHANNEL_TYPE_V913 = 54;
export const MINERU_BASE_URL_V913 = 'https://mineru.net';

export const isMinerUChannelV913 = (type) =>
  Number(type) === MINERU_CHANNEL_TYPE_V913;

export const getMinerUModeV913 = (config = {}) =>
  config.mineru_mode === '' ? 'precise' : config.mineru_mode ?? 'precise';

export function normalizeMinerUConfigV913(type, config = {}) {
  if (!isMinerUChannelV913(type)) return config;
  return { ...config, mineru_mode: getMinerUModeV913(config) };
}

export function buildMinerUConfigV913(type, config = {}) {
  if (!isMinerUChannelV913(type)) return config;
  const result = normalizeMinerUConfigV913(type, config);
  if (!['precise', 'agent'].includes(result.mineru_mode)) {
    throw new Error('channel.edit.mineru_v913.invalid_mode');
  }
  delete result.test_endpoint;
  delete result.protocol_capabilities_v5;
  result.edge_proxy = false;
  result.outbound_client_profile_v95 = '';
  return result;
}

export function getMinerUModelsV913(config = {}) {
  const { mineru_mode: mode } = buildMinerUConfigV913(54, config);
  return mode === 'agent'
    ? ['mineru-agent']
    : ['pipeline', 'vlm', 'MinerU-HTML'];
}

export function normalizeMinerUBaseURLV913(value = '') {
  const baseURL = String(value || '').trim() || MINERU_BASE_URL_V913;
  try {
    const parsed = new URL(baseURL);
    if (
      !/^https?:\/\/[^/?#\\@]+(?:\/[^?#\\]*)?$/i.test(baseURL) ||
      !['http:', 'https:'].includes(parsed.protocol) ||
      !parsed.hostname ||
      parsed.username ||
      parsed.password ||
      /[\s\\?#]/.test(baseURL)
    ) {
      throw new Error();
    }
    return baseURL.replace(/\/+$/, '');
  } catch (_) {
    throw new Error('channel.edit.mineru_v913.invalid_base_url');
  }
}

export function validateMinerUChannelV913({
  type,
  config,
  baseURL,
  keyRows = [],
  isEdit = false,
}) {
  if (!isMinerUChannelV913(type)) return;
  const { mineru_mode: mode } = buildMinerUConfigV913(type, config);
  normalizeMinerUBaseURLV913(baseURL);
  const hasCredential = keyRows.some((row) =>
    row.key_masked
      ? isEdit && Number.isInteger(Number(row.id)) && Number(row.id) > 0
      : Boolean(String(row.key_value || '').trim())
  );
  if (mode === 'precise' && !hasCredential) {
    throw new Error('channel.edit.mineru_v913.token_required');
  }
}

export function buildMinerUDiscoveryRequestV913(baseURL, config) {
  const { mineru_mode } = buildMinerUConfigV913(54, config);
  // This is a static catalog query, including when a saved channel has a draft mode.
  return {
    type: MINERU_CHANNEL_TYPE_V913,
    base_url: normalizeMinerUBaseURLV913(baseURL),
    config: { mineru_mode },
    keys: [],
  };
}
